import { render, staticRenderFns } from "./Preiserhoehung.vue?vue&type=template&id=099a06ef&scoped=true"
import script from "./Preiserhoehung.vue?vue&type=script&lang=js"
export * from "./Preiserhoehung.vue?vue&type=script&lang=js"
import style0 from "./Preiserhoehung.vue?vue&type=style&index=0&id=099a06ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099a06ef",
  null
  
)

export default component.exports